require('../../fhApp/currentUser/currentUser');
require('../../fhApp/appMetaService');
require('../../purchase/purchasePlanService');
require('../../fhApp/productService');

angular.module('app.pricing.plans.planCardController', [
  'app.currentUser',
  'app.appMetaService',
  'app.purchase.purchasePlanService',
  'app.productService'
])
  .controller('app.pricing.plans.planCardController', [
    '$scope',
    '$window',
    'currentUser',
    'appMetaService',
    'app.purchase.purchasePlanService',
    'app.productService',
    '$state',
    'PRODUCT',
    function ($scope, $window, currentUser, appMeta, purchasePlan, productService, $state, PRODUCT) {
      "use strict";
      //directive variables
      $scope.currentSubscription = $scope.currentSubscription || null;
      $scope.cardType = $scope.cardType || null;
      $scope.plans = $scope.plans || [];
      $scope.commonPlanAttrs = $scope.commonPlanAttrs || null;
      $scope.planTeams = $scope.planTeams || null;
      $scope.useTeams = $scope.useTeams || null;
      $scope.plan = $scope.plan || null;

      //scope variables used for subscription and team selections
      $scope.planTeam = { team: null };
      $scope.Subscription = { plan: $scope.plan ? $scope.plan : $scope.plans ? $scope.plans[0] : null };

      //scope variables for use of service functions and variable in html view
      $scope.appMeta = appMeta;
      $scope.showAuthButtons = false;
      $scope.subscriptionPauseAllowed = productService.isSubscriptionPauseEnabled();
      $scope.userLoggedIn = currentUser.is_logged_in();
      $scope.planGroups = {};
      $scope.productService = productService;

      let init = () => {
        switch ($scope.cardType) {
          case 'upgrade':
            // If the user has more than one subscription, we don't allow upgrades on the single day plan
            if ($scope.currentSubscription.plan_code === "ahl-single-day-all-access" && currentUser.subscriptions.recurly.length > 1) {
              return;
            }
            // If the subscription is not active, upgrades are not available for it
            if (!$scope.currentSubscription.is_active) {
              return;
            }

            _.forEach($scope.plans, (plan) => {
              switch (PRODUCT.Code) {
                case 'ahl':
                  switch (plan.type) {
                    case 'league':
                    case 'global':
                      if (!$scope.planGroups.hasOwnProperty('unlimitedAccess')) {
                        $scope.planGroups.unlimitedAccess = { title: 'Unlimited Access', plans: [], sortOrder: 1, hasTeams: false };
                      }

                      $scope.planGroups.unlimitedAccess.plans.push(plan);
                      break;
                    case 'team_all':
                    case 'team_home':
                    case 'team_away':
                      if (!$scope.planGroups.hasOwnProperty('teamAccess')) {
                        $scope.planGroups.teamAccess = { title: 'Single Team Access', plans: [], sortOrder: 2, hasTeams: true };
                      }

                      $scope.planGroups.teamAccess.plans.push(plan);
                      break;
                  }
                  break;
                case 'htv':
                  switch (plan.type) {
                    case 'global':
                      if (!$scope.planGroups.hasOwnProperty('unlimitedAccess')) {
                        $scope.planGroups.unlimitedAccess = { title: 'Unlimited Access', plans: [], sortOrder: 1, hasTeams: false };
                      }

                      $scope.planGroups.unlimitedAccess.plans.push(plan);
                      break;
                  }
                  break;
              }
            });

            $scope.planGroups = _.values($scope.planGroups);
            _.sortBy($scope.planGroups, ['sortOrder']);

            if (Array.isArray($scope.currentSubscription.teams) && $scope.planTeams) {
              _.forEach($scope.planTeams, (team) => {
                if (team.iteamid === $scope.currentSubscription.teams[0]) {
                  $scope.planTeam.team = team;
                  return;
                }
              })
            }
            break
        }
      };

      //function takes care of assigning params needed for purchasing subscriptions and displaying necessary alert messages for missing params
      let getRedirectParams = (plan) => {
        let params = { plan: plan ? plan : $scope.Subscription.plan };

        if (!params.plan) {
          alert('A subscription plan must be selected for purchase.');
          return null
        }

        if (productService.planUsesTeams(params.plan)) {
          if (!$scope.planTeam.team) {
            alert('A team must be selected if purchasing a team subscription.');
            return null
          } else {
            params.team = $scope.planTeam.team;
          }
        }

        return params;
      };

      $scope.upgradeOrSubscribeText = () => {
        if ($scope.currentSubscription && $scope.currentSubscription.state === 'canceled') {
          return 'Subscribe';
        }

        return 'Upgrade';
      };

      $scope.cancel = function () {
        let cancelSubscription = confirm("You are about to cancel your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to disable your auto-renewal?");
        if (cancelSubscription === true) {
          purchasePlan.update_subscription('cancel', null, $scope.currentSubscription).then(response => {
            $state.reload();
          });
        }
      };

      $scope.pause = function () {
        let suspendSubscription = confirm("You are about to pause your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to pause?");
        if (suspendSubscription === true) {
          purchasePlan.update_subscription('pause', null, $scope.currentSubscription)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                } else {
                  $state.reload();
                }
              }
            );
        }
      };

      $scope.cancelPause = function () {
        let cancelPause = confirm("You are about to cancel the schedule pause of your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to continue?");
        if (cancelPause === true) {
          purchasePlan.update_subscription('cancel_pause', null, $scope.currentSubscription)
            .then(
              response => {
                let data = response.data;
                $state.reload();

                if (data.error) {
                  alert(data.error);
                }
              }
            );
        }
      };

      $scope.resume = function () {
        let resumeSubscription = confirm("You are about to resume your " + $scope.currentSubscription.plan.name + " subscription. Do you wish to continue?");
        if (resumeSubscription === true) {
          purchasePlan.update_subscription('resume', null, $scope.currentSubscription).then(() => {
            $state.reload();
          });
        }
      };

      $scope.renew = function () {
        let renewSubscription = confirm("You are about to re-activate your " + $scope.currentSubscription.plan.name + " subscription. Do you wish to continue?");
        if (renewSubscription === true) {
          purchasePlan.activate_subscription($scope.currentSubscription.uuid).then(() => {
            $state.reload();
          });;
        }
      };

      $scope.subscribe = (plan, upgrade) => {
        if (currentUser.is_logged_in()) {
          let params = getRedirectParams(plan);

          if (params && upgrade) {
            params.upgrade = true;
            params.uuid = $scope.currentSubscription.uuid;
          }

          let redirect_info = {
            redirect_url: 'app.purchase.billingInfo',
            redirect_params: params
          };

          if (params) {
            if (!currentUser.checkUserInfo(redirect_info)) {
              $state.go('app.purchase.billingInfo', redirect_info.redirect_params);
            }
          }
        } else {
          $scope.showAuthButtons = true;
        }
      };

      $scope.upgrade = (plan, uuid) => {
        if (currentUser.is_logged_in()) {
          let params = getRedirectParams(plan);

          params.upgrade = true;
          params.uuid = $scope.currentSubscription.uuid;

          let redirect_info = {
            redirect_url: 'app.purchase.billingInfo',
            redirect_params: params
          };

          if (params) {
            if (!currentUser.checkUserInfo(redirect_info)) {
              $state.go('app.purchase.billingInfo', redirect_info.redirect_params);
            }
          }
        } else {
          $scope.showAuthButtons = true;
        }
      };

      $scope.login = (plan) => {
        let params = getRedirectParams(plan);

        if (params) {
          $state.go('app.login', { redirect: 'app.purchase.billingInfo', redirectParams: params });
        }
      };

      $scope.register = (plan) => {
        let params = getRedirectParams(plan);

        if (params) {
          $state.go('app.registration.new', {
            plan_code: params.plan.plan_code,
            team: params.team ? params.team.iteamid : null
          });
        }
      };

      //AHL Promotion
      $scope.showPromotion = currentUser.showPromotion();

      //AHL Black Friday
      $scope.showBlackFriday = currentUser.showBlackFriday();

      //AHL MidSeason
      $scope.showMidSeason = currentUser.showMidSeason();

      //AHL Final Price Drop
      $scope.showFinalPriceDrop = currentUser.showFinalPriceDrop();

      //AHL Playoffs 2023
      $scope.showPlayoffs = currentUser.showPlayoffs();

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/pricing/plans/planCardController.js